import React from 'react';
import EdsPagination from '@hedtech/react-design-system/core/es/Pagination';
const Pagination = (props) => (React.createElement(EdsPagination, Object.assign({}, props)));
Pagination.defaultProps = {
    rowsPerPageShowAll: true
};
export default Pagination;
